/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import './font/style.css';
import './png/style.css';

const propTypes = {
  name: PropTypes.string
};

const defaultProps = {
  name: ''
};

const Icon = ({ name, className, title, ...props }) => (
  <i 
    title={title || ''}
    style={{ cursor: "pointer" }} 
    onMouseDown={(e) => {if(props.onMouseDown) props.onMouseDown(e);}} 
    className={`icon-${name} ${className || ''}`} 
    {...props} 
  />
);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default styled(Icon)``;